import { IReportPeriod } from 'partner360/models/report/iReportPeriod'
import { ISobAnalyticsReportJoined } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportJoined'

interface IParams {
  selectedPeriod: IReportPeriod | undefined
}

type IsExcludedField = keyof Pick<
  ISobAnalyticsReportJoined,
  | 'IsExcluded'
  | 'IsExcludedQuarterlyQ1'
  | 'IsExcludedQuarterlyQ2'
  | 'IsExcludedQuarterlyQ3'
  | 'IsExcludedQuarterlyQ4'
  | 'IsExcludedQuarterlyQ1Q2'
  | 'IsExcludedQuarterlyQ1Q2Q3'
  | 'IsExcludedQuarterlyQ3Q4'
  | 'IsExcludedQuarterlyQ1Q2Q3Q4'
>

export const getExcludedField = ({ selectedPeriod }: IParams): IsExcludedField => {
  if (selectedPeriod) {
    const period = selectedPeriod.Quarters.split(',').join('')
    const field = `IsExcludedQuarterly${period}` as IsExcludedField
    return field
  }

  return 'IsExcluded'
}
